import { render, staticRenderFns } from "./BE.Protect.vue?vue&type=template&id=349048eb&scoped=true&"
import script from "./BE.Protect.vue?vue&type=script&lang=ts&"
export * from "./BE.Protect.vue?vue&type=script&lang=ts&"
import style0 from "./BE.Protect.vue?vue&type=style&index=0&id=349048eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349048eb",
  null
  
)

export default component.exports